var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("strong", [_vm._v(_vm._s(_vm.labelDate))]),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-caret-down" })
    ]),
    _vm._v(" "),
    _c("small", [
      _vm._v(
        _vm._s(_vm.startDateFmt) +
          _vm._s(_vm.endDate ? " - " : "") +
          _vm._s(_vm.endDateFmt)
      )
    ]),
    _vm._v(" "),
    _c("input", { staticClass: "datepicker-here", attrs: { type: "text" } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }